module.exports = __webpack_public_path__ + "static/media/disappointingEmoji.0786e03f.svg";